import React from 'react';
import {
  FileLinesIcon,
  GiftIcon,
  PhotoFilmIcon,
  CircleDollarIcon,
  SackDollarIcon,
  UserPlusIcon,
  EnvelopeIcon,
  ChartTreeMapIcon,
  UserGroupIcon
} from '@revfluence/fresh-icons/solid/esm';
import { cn } from '@frontend/shadcn/lib/utils';
import { Button } from '@/shadcn/components/ui/button';
import { Avatar, AvatarFallback } from '@/shadcn/components/ui/avatar';

interface StatisticItemProps {
  icon: React.ReactNode;
  value: string | number;
  label: string;
  className?: string;
}

const StatisticItem: React.FC<StatisticItemProps> = ({ icon, value, label, className }) => (
  <div className={cn('flex items-center gap-2', className)}>
    <div className="flex items-center justify-center text-grey-5">
      {icon}
    </div>
    <div className="flex items-center gap-1">
      <span className="text-grey-6 text-sm font-medium">{value}</span>
      <span className="text-grey-5 text-sm font-normal">{label}</span>
    </div>
  </div>
);

export const SummaryHeader = () => {
  return (
    <div className="w-full py-2 bg-white border-b border-grey-2 flex flex-col">
      <div className="px-8 flex items-center justify-between gap-6">
        <div className="flex-1 flex items-center gap-6">
          <StatisticItem
            icon={<UserGroupIcon />}
            value={0}
            label="Members"
          />
          <StatisticItem
            icon={<FileLinesIcon />}
            value={0}
            label="Briefs"
          />
          <StatisticItem
            icon={<GiftIcon />}
            value={0}
            label="Products"
          />
          <StatisticItem
            icon={<PhotoFilmIcon />}
            value={0}
            label="Content"
          />
          <StatisticItem
            icon={<CircleDollarIcon />}
            value="$0"
            label="Revenue"
          />
          <StatisticItem
            icon={<SackDollarIcon />}
            value="$0"
            label="Budget"
            className="ml-auto"
          />
        </div>

        <div className="flex items-center gap-2">
          <Avatar className="w-8 h-8 border-2 border-white">
            <AvatarFallback className="bg-blue-3 text-grey-6 text-xs font-medium">
              LV
            </AvatarFallback>
          </Avatar>

          <div className="flex items-center gap-2 ml-2">
            <Button
              variant="primary"
              size="sm"
              className="gap-2"
            >
              <UserPlusIcon className="w-3.5 h-3.5" />
              Invite
            </Button>

            <Button
              variant="outline"
              size="headerIcon"
            >
              <EnvelopeIcon className="w-3.5 h-3.5" />
            </Button>

            <Button
              variant="outline"
              size="headerIcon"
            >
              <ChartTreeMapIcon className="w-3.5 h-3.5" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
